module.exports = __webpack_public_path__ + "img/san-jose-resort.1b41ce31.jpg";